export enum TextDecoration {
    NONE = 'NONE',
    UNDERLINE = 'UNDERLINE',
    STRIKETHROUGH = 'STRIKETHROUGH',
}
